import { Component } from '@angular/core';

export const USER_GUIDE_URL =
    'https://ishareteam9.na.xom.com/sites/LVC%20Analytics/DAS%20LVC%20Internal/LPA%20Sharing/3.%20Projects/Lighthouse/User%20Guide.pptx?web=1';

@Component({
    selector: 'lh-user-guide-button',
    standalone: false,
    template: `<lh-lvc-request-button
        label="User Guide"
        tooltip="Open the Lighthouse user guide in a new tab"
        [href]="href"
    ></lh-lvc-request-button>`,
    styles: [':host { display: inline-flex; align-items: center; }'],
})
export class LhUserGuideButtonComponent {
    readonly href = USER_GUIDE_URL;
}
